import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getVehicles } from '../../redux/actions/vehicles';
import {
  Title,
  Notification,
  RouteWrapper,
  Permission,
  VehicleCreateForm,
  VehicleList,
} from '../../components';

interface Props {
  vehicles: any;
  vehicleTypes: Array<any>;
  isFetching: boolean;
  dispatch: Function;
}

class Route extends React.Component<Props> {
  componentDidMount() {
    this.props.dispatch(getVehicles());
  }

  render() {
    return (
      <RouteWrapper
        title="Vehicles"
        requireAuth
        requirePermission="MANAGE_VEHICLES"
        breadcrumbs={[
          { link: '/settings', text: 'Settings' },
          { link: '/settings/vehicles', text: 'Vehicles' },
        ]}
        loading={this.props.isFetching}
      >
        <div className="container">
          <div className="columns">
            <div className="column">
              <Title>Vehicles</Title>
              {(!this.props.isFetching || this.props.vehicles.length > 0) && (
                <VehicleList
                  items={this.props.vehicles}
                  showVehicleFilter
                  vehicleTypes={this.props.vehicleTypes}
                />
              )}
            </div>
            <div className="column is-5">
              <div className="block">
                <VehicleCreateForm />
              </div>
              <Permission require="MANAGE_VEHICLE_TYPES">
                <Link to="/settings/vehicles/types">
                  <Notification type="primary">
                    Click here to manage vehicle types.
                  </Notification>
                </Link>
              </Permission>
            </div>
          </div>
        </div>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({ vehicles, vehicleTypes }) => ({
  isFetching: vehicles.isFetching,
  vehicles: vehicles.vehicles,
  vehicleTypes: vehicleTypes.isFetching ? [] : vehicleTypes.vehicleTypes,
});

export default connect(mapStateToProps)(Route);
